  
export class NotificationDismissMessage {
  public notificationId: string;
  constructor(notificationId: string) {
    this.notificationId = notificationId;
  }
}